import { IPFS_GATEWAY } from './index'
import { Team } from './types'
import i18next from '../i18n'

const teams: Team[] = [
  {
    id: 1,
    name: i18next.t('CONSTANT_18'),
    description: i18next.t('CONSTANT_19'),
    images: {
      lg: require('assets/images/teams/dizzy-spirits-md.png').default,
      md: require('assets/images/teams/dizzy-spirits-md.png').default,
      sm: require('assets/images/teams/dizzy-spirits-sm.png').default,
      alt: require('assets/images/teams/dizzy-spirits-md.png').default,
      ipfs: `${IPFS_GATEWAY}/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/dizzy-spirits-banner.png`,
    },
    background: require('assets/images/teams/dizzy-spirits-banner.png').default,
    textColor: '#191326',
    users: 0,
    points: 0,
  },
  {
    id: 2,
    name: i18next.t('CONSTANT_20'),
    description: i18next.t('CONSTANT_21'),
    images: {
      lg: require('assets/images/teams/beer-club-md.png').default,
      md: require('assets/images/teams/beer-club-md.png').default,
      sm: require('assets/images/teams/beer-club-sm.png').default,
      alt: require('assets/images/teams/beer-club-md.png').default,
      ipfs: `${IPFS_GATEWAY}/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/beer-club-banner.png`,
    },
    background: require('assets/images/teams/beer-club-banner.png').default,
    textColor: '#FFFFFF',
    users: 0,
    points: 0,
  },
  {
    id: 3,
    name: i18next.t('CONSTANT_22'),
    description: i18next.t('CONSTANT_23'),
    images: {
      lg: require('assets/images/teams/path-of-brew-md.png').default,
      md: require('assets/images/teams/path-of-brew-md.png').default,
      sm: require('assets/images/teams/path-of-brew-sm.png').default,
      alt: require('assets/images/teams/path-of-brew-md.png').default,
      ipfs: `${IPFS_GATEWAY}/QmXKzSojwzYjtDCVgR6mVx7w7DbyYpS7zip4ovJB9fQdMG/path-of-brew-banner.png`,
    },
    background: require('assets/images/teams/path-of-brew-banner.png').default,
    textColor: '#191326',
    users: 0,
    points: 0,
  },
]

export default teams
